import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "@/context/ThemeContext";
import { ContentProvider } from "@/context/ContentContext";
import { CartProvider } from "@/context/CartContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Promotions from "@/pages/Promotions";
import Contact from "@/pages/Contact";
import Career from "@/pages/Career";
import Terms from "@/pages/Terms";
import CommandeScolaire from "@/pages/CommandeScolaire";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Commande from "@/pages/Commande";
import Compte from "@/pages/Compte";
import AuthCallback from "@/components/AuthCallback";
import ScrollToTop from "@/components/ScrollToTop";
import ConsentModal from "@/components/ConsentModal";

function AppRouter() {
  const location = useLocation();
  // Check URL fragment for session_id from OAuth callback - must be synchronous
  if (location.hash?.includes('session_id=') && location.pathname === '/auth-callback') {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/a-propos" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/promotions-et-evenements" element={<Promotions />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/carriere" element={<Career />} />
        <Route path="/commande" element={<Commande />} />
        <Route path="/compte" element={<Compte />} />
        <Route path="/auth-callback" element={<AuthCallback />} />
        <Route path="/termes-et-conditions" element={<Terms />} />
        <Route path="/scolaire" element={<CommandeScolaire />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <ThemeProvider>
      <CartProvider>
      <ContentProvider>
      <ConsentModal />
      <BrowserRouter>
        <ScrollToTop />
        <AppRouter />
      </BrowserRouter>
      </ContentProvider>
      </CartProvider>
    </ThemeProvider>
  );
}

export default App;
